/**
 * SimulateTemplateDialog — Mode test emails (envoi à sa propre adresse).
 */
import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, Send } from "lucide-react";
import { toast } from "sonner";

export default function SimulateTemplateDialog({ event, open, onOpenChange }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState(null);
  const submit = async () => {
    if (!email) { toast.error("Adresse email requise"); return; }
    setSending(true);
    try {
      const r = await api.post("/hr/email-templates/simulate", { event, to_email: email });
      setPreview(r.data);
      if (r.data.ok) toast.success("Email de test envoyé ✓");
      else toast.warning(`Aperçu généré (envoi Resend : ${r.data.error || "échec"})`);
    } catch (e) { toast.error(apiError(e)); }
    finally { setSending(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="simulate-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-purple-500" /> Simuler l'email · {event}
          </DialogTitle><DialogDescription className="sr-only">Détails de la modale.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Envoyer un test à</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="votre-email@..." data-testid="sim-email" />
            <p className="text-xs text-slate-500 mt-1">
              Testez le rendu et la délivrabilité avant d'activer en prod.
            </p>
          </div>
          {preview && (
            <div className="space-y-2 border-t pt-3">
              <div className="text-xs text-slate-500">Aperçu du sujet :</div>
              <div className="p-2 bg-slate-50 rounded text-sm font-mono">{preview.subject_preview}</div>
              <div className="text-xs text-slate-500">Aperçu HTML :</div>
              <div className="max-h-64 overflow-auto border rounded p-2 bg-white text-xs"
                dangerouslySetInnerHTML={{ __html: preview.html_preview }} />
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Fermer</Button>
          <Button onClick={submit} disabled={sending}
            className="bg-purple-600 hover:bg-purple-700 text-white" data-testid="sim-send-btn">
            <Send className="w-4 h-4 mr-1.5" /> {sending ? "Envoi..." : "Envoyer test"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
